import React, { Component } from "react";
import StepWizard from 'react-step-wizard';
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Paso1 from "./SicoopPaso1";
import Paso2 from "./SicoopPaso2";
import Paso3 from "./SicoopPaso3";
import Paso4 from "./SicoopPaso4";
import Paso5 from "./SicoopPaso5";



export default class SicoopPago extends Component {
  constructor(props) {
    super(props);
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
    this.paso5 = React.createRef();
    this.state = {
      resultadoPaso1: undefined,
      resultadoPaso2: undefined,
      resultadoPaso3: undefined,
      datosCliente: undefined,
      detalleCuotas: undefined,
      buscar: undefined,
      ticket: undefined,
      datosPopUp: undefined,
      tipoTrx: undefined,
      esGrilla: undefined,
      formOriginal: undefined,
      idOperacion:undefined,
      parametersResponse:undefined,
      monto:undefined,
      codigoServicio: sessionStorage.getItem("servicio"),
      nombreServicio: sessionStorage.getItem("nombre"),
      imgServicio: sessionStorage.getItem("img"),
      entidadServicio: sessionStorage.getItem("entidad"),
      entidadId:sessionStorage.getItem('codigoEntidad'),
      networkParticipantCode: sessionStorage.getItem('networkParticipantCode'),
      network:sessionStorage.getItem('network'),
      cuentaOrigenSelected:undefined,
      numCuentaDestino:undefined,
      docDestinatario:undefined,
      paymentService:undefined,
      comision:undefined,
      itemSelected:undefined,
      modalidadPago : undefined,
      // tipoTarjeta : undefined,
      comprobante:undefined,
      nroOperacion:undefined,
      // nroCuentaTarjeta:undefined
      barraAgregada : false,
    };
  }

  componentDidMount() {
    // this.isPaso1.click();
  }

  respuestaPaso1 = (idOperacion,parametersResponse, buscar, tipoTrx, original,monto,_paymentService,_comision) => {
    this.setState({
      comision : _comision,
      paymentService:_paymentService,
      monto: monto, 
      resultadoPaso1: parametersResponse, 
      buscar: buscar, 
      tipoTrx: tipoTrx, 
      formOriginal: original,
      idOperacion:idOperacion,
      parametersResponse:parametersResponse
    });
  };

  respuestaPaso2 = (
    _itemSelected,
    _comision,
    _paymentService,
    _docDestinatario,
    _montoTotal,
    dataFromChild, 
    // tipoTrx, 
    // esGrilla, 
    // servicio, 
    datosCliente,
    _numCuentaDestino,
    _barraAgregada
  ) => {
    this.setState({ 
      itemSelected:_itemSelected,
      comision:_comision,
      resultadoPaso2: dataFromChild, 
      // tipoTrx: tipoTrx, 
      // esGrilla: esGrilla, 
      datosCliente: datosCliente,
      numCuentaDestino:_numCuentaDestino,
      docDestinatario:_docDestinatario,
      monto:_montoTotal,
      paymentService:_paymentService,
      barraAgregada:_barraAgregada
    });
  };

  respuestaPaso3 = (dataFromChild, montoPagado, rptAnterior) => {
    // var resultado3 = []
    // var jsonData = JSON.parse(JSON.stringify(rptAnterior));
    // for (var i = 0; i < jsonData.length; i++) {
    //   var datos = JSON.parse(JSON.stringify(jsonData[i]));
    //   datos.concepto = datos.name;
    //   datos.valor = toString(datos.value).split(".").join("");
    //   resultado3.push(datos);
    // }
    this.setState({ 
      cuentaOrigenSelected:dataFromChild , 
      // resultadoPaso3: resultado3, 
      // modalidadPago : modalidadPago , 
      // tipoTarjeta : _tipoTarjeta,
      // nroCuentaTarjeta:_nroCuentaTarjeta
    });
  };


respuestaPaso4 = (_ticket , _nroOperacion,monto , datos) => {
  this.setState({ 
    ticket : _ticket ,
    nroOperacion : _nroOperacion ,
    comprobante : datos 
  });
};


render() {
  return (
    <div className="content-wrapper">
      <Titulo texto="Pagos de Servicios CABAL" />
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <StepWizard transitions="none" >
                    <Paso1 
                      ref={this.paso1} 
                      codigoServicio={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombreServicio={this.state.nombreServicio}
                      entidadId = {this.state.entidadId}
                      networkParticipantCode = {this.state.networkParticipantCode}
                      respuestaPaso1={this.respuestaPaso1.bind(this)} 
                      formulario={this.state.formOriginal}
                      network={this.state.network}
                    />
                    <Paso2 
                      ref={this.paso2} 
                      idOperacion = {this.state.idOperacion}
                      parametersResponse = {this.state.parametersResponse}
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      buscar={this.state.buscar} 
                      respuestaPaso2={this.respuestaPaso2.bind(this)}
                      network={this.state.network}
                    />
                    <Paso3 
                      ref={this.paso3}  
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio} 
                      paso1={this.state.resultadoPaso1} 
                      buscar={this.state.buscar} 
                      respuestaPaso3={this.respuestaPaso3.bind(this)} 
                      paso2={this.state.resultadoPaso2}
                    />
                    <Paso4 
                      ref={this.paso4} 
                      codigo={this.state.codigoServicio} 
                      networkParticipantCode={this.state.networkParticipantCode}
                      entidadId={this.state.entidadId}
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio}
                      respuestaPaso4={this.respuestaPaso4.bind(this)} 
                      // tipoTrx={this.state.tipoTrx} 
                      datosCliente={this.state.datosCliente}  
                      idOperacion={this.state.idOperacion}
                      cuentaOrigenSelected={this.state.cuentaOrigenSelected}
                      monto={this.state.monto}
                      numCuentaDestino={this.state.numCuentaDestino}
                      docDestinatario={this.state.docDestinatario}
                      paymentService={this.state.paymentService}
                      comision={this.state.comision}
                      modalidadPago = {this.state.modalidadPago}
                      barraAgregada={this.state.barraAgregada}
                    />
                    <Paso5 
                      ref={this.paso5} 
                      codigo={this.state.codigoServicio} 
                      img={this.state.imgServicio} 
                      empresa={this.state.entidadServicio} 
                      nombre={this.state.nombreServicio}
                      nroOperacion={this.state.nroOperacion}
                      modalidadPago={this.state.modalidadPago}
                      monto={this.state.monto}
                      comision={this.state.comision}
                      comprobante={this.state.comprobante}
                      cuentaOrigenSelected={this.state.cuentaOrigenSelected}
                      nombreServicio={this.state.nombreServicio}
                    />
                  </StepWizard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button
        hidden
        ref={(a) => (this.isPaso1 = a)}
        className="btn btn-cu-primary"
        onClick={this.props.firstStep}
      ></button>
     
    </div>

  );

}
}